<section
  markdown
  ngPreserveWhitespaces
  appDynamicMarkdownLink
  [@fadeUp]="{ value: loaded ? '' : 'void', params: { time: 600, delay: 0 } }"
>
  {{ block.body }}
</section>
